__turbopack_context__.v({
  "arrow": "Row-module-scss-module__VF9nqa__arrow",
  "item": "Row-module-scss-module__VF9nqa__item",
});
